import { render, staticRenderFns } from "./TabPage.vue?vue&type=template&id=a838a284&scoped=true&"
import script from "./TabPage.vue?vue&type=script&lang=js&"
export * from "./TabPage.vue?vue&type=script&lang=js&"
import style0 from "./TabPage.vue?vue&type=style&index=0&id=a838a284&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a838a284",
  null
  
)

export default component.exports